import Vue from 'vue';

Vue.directive('click-outside', 
{
  	bind: function (el, binding, vnode) {
    	el.clickOutsideEvent = function (event) {
			// here I check that click was outside the el and his children
			if ( ! (el == event.target || el.contains(event.target))) {
				  		console.info('a');
				// and if it did, call method provided in attribute value
				vnode.context[binding.expression](event);
			}
    	};

    	document.body.addEventListener('click', el.clickOutsideEvent)
  	},

  	unbind: function (el) {
    	document.body.removeEventListener('click', el.clickOutsideEvent)
  	},
});

Vue.filter('decimal', function (value)
{
    return parseFloat(value).toString().replace('.', ',');
});

Vue.filter('percentage', function (value)
{
    if (isNaN(value)) return 0;
    return parseFloat(value).toFixed(2).replace('.', ',') + ' %';
});

Vue.filter('money_string', function (value, currency)
{
    if ( ! currency) currency = '€';
    return parseFloat(value).toFixed(2).replace('.', ',') + ' ' + currency;
});

Vue.filter('hours', function (value)
{
    return parseFloat(value).toFixed(2).replace('.', ',') + ' ' + Vue.t('text.hrs');
});

Vue.filter('distance', function (value, unit)
{
    if ( ! unit) unit = 'km';
    return parseFloat(value).toFixed(2).replace('.', ',') + ' ' + unit;
});

Vue.filter('floor', function(value, separator)
{
    if (separator) return parseFloat(value).toFixed(2).toString().replace('.', ',');

    let floor = parseFloat(value).toFixed(2);

    return floor;
});

Vue.filter('money_float', {
    read: function (value)
    {
        if ( ! value) return value;
        return parseFloat(value).toFixed(2);
    },
    write: function (value)
    {
        return value;
    }
});

Vue.filter('readableDate', (value, formatIn, formatOut) =>
{
    try
    {
        if (formatIn && formatOut) {
            return moment(value, formatIn).format(formatOut);
        }

        return moment(value).format(formatIn);
    }
    catch (e)
    {
        return value;
    }
});

Vue.filter('at', (value, at) =>
{
    return _.at(value, at)[0] || 0;
});

/**
 * Convert dash to 0
 *
 * @param val
 * @returns {*}
 */
Vue.filter('pause', (value) =>
{
	return (value === '\u2014') ? 0 : value;
});

Vue.filter('reverse', (value) =>
{
    return value.splice().reverse();
});

Vue.filter('factor', (value, dividendAt, divisorAt) =>
{
    let res = parseFloat(_.at(value, dividendAt)[0]) / parseFloat(_.at(value, divisorAt)[0])
    return (isFinite(res))? res * 100 : 0.00;
});



// WEBPACK FOOTER //
// ./src/js/filters.js